import React, {memo, useState} from 'react';
import useStyles from './useStyles';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {MobileTimePicker} from '@mui/x-date-pickers/';

export const TimePicker = memo((props) => {

    const classes = useStyles()

    const {
        label,
        value,
        onChangeCallback = () => {},
        fullWidth,
        size,
        variant} = props

    const [time, setTime] = useState(moment(value));

    const timeChangeHandler = (e)=>{

        if (!value) return
        // при изменении времени объединяем дату из входных параметров и выбранное время !!!
        const newTime = moment(value)
            .hours(e.hours())
            .minutes(e.minutes())
            .seconds(0); // Обнуляем секунды для корректной работы

        setTime(newTime);
    }

    const onAcceptHandler = () => {
        // вызвать коллбэк только при кнопке - ок !!!
        onChangeCallback(moment(time).toDate());
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ru">
            <MobileTimePicker
                onChange={timeChangeHandler}
                value={moment(value)}
                defaultValue={moment(value)}
                {...{label}}
                slotProps={{ textField: { size: 'small', variant:"standard" } }}
                fullWidth={fullWidth}
                size={size}
                variant={variant}
                className={classes.time}
                onAccept={onAcceptHandler}
            />
        </LocalizationProvider>
    )
})